import { render, staticRenderFns } from "./AgreementPrivateLabel.vue?vue&type=template&id=247d74ed&scoped=true"
import script from "./AgreementPrivateLabel.vue?vue&type=script&lang=js"
export * from "./AgreementPrivateLabel.vue?vue&type=script&lang=js"
import style0 from "./AgreementPrivateLabel.vue?vue&type=style&index=0&id=247d74ed&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247d74ed",
  null
  
)

export default component.exports